var $ = require('jquery');

var toggleMenu = function () {
    $('#mainmenu .has-submenu').removeClass('active');
    $('#mainmenu .menu').slideToggle();
};

$(function () {
    $('#mainmenu .toggle-menu').click(toggleMenu);
    $('#mainmenu .has-submenu').click(function(e){
        $(this).toggleClass('active');
    });
});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/mainmenu.js
// module id = 25
// module chunks = 0